import { _ } from '@zto/zpage'

/**
 * @param fnSymbol
 * @param fn
 * @returns
 * 当同一个标识的函数，执行时，将进行拦截，当第一个拦截的函数完成后，同步返回
 * e.g. 当多个组件同时发起登录时，只有第一个登录被执行，执行结果将交给所有的函数
 */

export interface ExecuteResult<T = any> {
  success: boolean
  error?: any
  result?: T
}

export type ExecuteFn<T = any> = (() => T) | (() => Promise<T>)

export interface ExecuteQueue {
  loading: boolean // 是否执行中
  promises: any[] // 执行resolve, reject
  fn: ExecuteFn // 执行方法
}

const __executeQueueMap = new WeakMap<Symbol | ExecuteFn, ExecuteQueue>()

export async function blockExecute<T>(fn: ExecuteFn<T>)

export async function blockExecute<T>(fnSymbol: Symbol, fn: ExecuteFn<T>)

export async function blockExecute<T>(fnSymbol: Symbol | ExecuteFn<T>, fn?: ExecuteFn<T>): Promise<ExecuteResult<T>> {
  let qSymbol = fnSymbol

  if (typeof fnSymbol === 'function') {
    qSymbol = fnSymbol
    fn = fnSymbol
  }

  if (!fn || !_.isFunction(fn)) {
    throw new Error('请提供方法')
  }

  if (!_.isSymbol(qSymbol) && !_.isFunction(qSymbol)) {
    throw new Error('标签必须为symbol或function且保持全局唯一')
  }

  let q = __executeQueueMap.get(qSymbol)

  if (!q) {
    q = { loading: false, promises: [], fn }
    __executeQueueMap.set(qSymbol, q)
  }

  const p = new Promise<ExecuteResult<T>>((r, j) => {
    q.promises.push([r, j])
  })

  if (!q.loading) {
    q.loading = true
    const promises = q.promises

    try {
      const result = await Promise.resolve().then(() => q!.fn())

      q.loading = false
      __executeQueueMap.delete(fnSymbol)

      promises.forEach(([r, j]) => r({ success: true, result }))
    } catch (ex) {
      q.loading = false
      __executeQueueMap.delete(fnSymbol)

      promises.forEach(([r, j]) => r({ success: false, error: ex }))
    }
  }

  return p
}
